"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var EPG_1 = require("stremio/common/EPG");
var useGuideViewport = function (dayStart, dayEnd, now) {
    var viewportRef = (0, react_1.useRef)(null);
    var headerRef = (0, react_1.useRef)(null);
    var channelColumnRef = (0, react_1.useRef)(null);
    var nowRef = (0, react_1.useRef)(now);
    var positionRef = (0, react_1.useRef)({ day: '', center: null });
    var _a = (0, react_1.useState)({ left: 0, top: 0, width: 0, height: 0, minTickWidth: 100 }), viewport = _a[0], setViewport = _a[1];
    var _b = (0, react_1.useState)(EPG_1.EPG_PIXELS_PER_HOUR), pixelsPerHour = _b[0], setPixelsPerHour = _b[1];
    (0, react_1.useEffect)(function () {
        nowRef.current = now;
    }, [now]);
    (0, react_1.useLayoutEffect)(function () {
        var element = viewportRef.current;
        if (!element)
            return;
        var frame = null;
        var measure = function () {
            frame = null;
            if (headerRef.current)
                headerRef.current.scrollLeft = element.scrollLeft;
            if (channelColumnRef.current)
                channelColumnRef.current.style.transform = "translateY(-".concat(element.scrollTop, "px)");
            var minTickWidth = 6.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
            setViewport({ left: element.scrollLeft, top: element.scrollTop, width: element.clientWidth, height: element.clientHeight, minTickWidth: minTickWidth });
        };
        var onScroll = function () {
            if (frame === null)
                frame = requestAnimationFrame(measure);
        };
        var observer = new ResizeObserver(onScroll);
        observer.observe(element);
        element.addEventListener('scroll', onScroll, { passive: true });
        measure();
        return function () {
            observer.disconnect();
            element.removeEventListener('scroll', onScroll);
            if (frame !== null)
                cancelAnimationFrame(frame);
        };
    }, []);
    var scrollToTime = (0, react_1.useCallback)(function (time) {
        var element = viewportRef.current;
        if (!element)
            return;
        element.scrollLeft = Math.max(0, ((time - dayStart) / EPG_1.HOUR_IN_MS) * pixelsPerHour - element.clientWidth / 2);
    }, [dayStart, pixelsPerHour]);
    // Day changes select Now; zoom preserves the time at the viewport centre.
    (0, react_1.useLayoutEffect)(function () {
        var element = viewportRef.current;
        if (!element)
            return;
        var day = "".concat(dayStart, ":").concat(dayEnd);
        var time = positionRef.current.center;
        if (positionRef.current.day !== day) {
            element.scrollTop = 0;
            time = nowRef.current >= dayStart && nowRef.current < dayEnd ? nowRef.current : dayStart;
        }
        positionRef.current = { day: day, center: null };
        if (time === null)
            return;
        element.scrollLeft = Math.max(0, ((time - dayStart) / EPG_1.HOUR_IN_MS) * pixelsPerHour - element.clientWidth / 2);
        if (headerRef.current)
            headerRef.current.scrollLeft = element.scrollLeft;
        setViewport(function (previous) { return (__assign(__assign({}, previous), { left: element.scrollLeft, top: element.scrollTop })); });
    }, [dayStart, dayEnd, pixelsPerHour]);
    var zoom = (0, react_1.useCallback)(function (factor) {
        var element = viewportRef.current;
        if (!element)
            return;
        var next = Math.max(EPG_1.EPG_MIN_PIXELS_PER_HOUR, Math.min(EPG_1.EPG_MAX_PIXELS_PER_HOUR, pixelsPerHour * factor));
        if (next === pixelsPerHour)
            return;
        positionRef.current.center = dayStart + (element.scrollLeft + element.clientWidth / 2) * EPG_1.HOUR_IN_MS / pixelsPerHour;
        setPixelsPerHour(next);
    }, [dayStart, pixelsPerHour]);
    return { viewportRef: viewportRef, headerRef: headerRef, channelColumnRef: channelColumnRef, viewport: viewport, pixelsPerHour: pixelsPerHour, zoom: zoom, scrollToTime: scrollToTime };
};
exports.default = useGuideViewport;
